var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "formsection w-100" },
        _vm._l(_vm.item.items, function (section_item) {
          return _c(_vm.capitalize(section_item.data.view), {
            key: section_item.data.id,
            tag: "component",
            attrs: {
              item: section_item,
              values: _vm.values,
              errors: _vm.errors,
              "answer-options": _vm.answerOptions,
              "form-values": _vm.formValues,
            },
            on: { "update-form-value": _vm.updateFormValue },
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }